"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyUatComment = exports.StudyUat = exports.StudyUatDialogVisibilityState = exports.StudyUatStatus = exports.StudyUatCategory = void 0;
var StudyUatCategory;
(function (StudyUatCategory) {
    StudyUatCategory["EntryScreen"] = "ENTRY_SCREEN";
    StudyUatCategory["Trigger"] = "TRIGGER";
    StudyUatCategory["Role"] = "ROLE";
    StudyUatCategory["Privilege"] = "PRIVILEGE";
    StudyUatCategory["Other"] = "OTHER";
})(StudyUatCategory = exports.StudyUatCategory || (exports.StudyUatCategory = {}));
var StudyUatStatus;
(function (StudyUatStatus) {
    StudyUatStatus["Submitted"] = "SUBMITTED";
    StudyUatStatus["Accepted"] = "ACCEPTED";
    StudyUatStatus["Applied"] = "APPLIED";
    StudyUatStatus["Completed"] = "COMPLETED";
    StudyUatStatus["Cancelled"] = "CANCELLED";
})(StudyUatStatus = exports.StudyUatStatus || (exports.StudyUatStatus = {}));
var StudyUatDialogVisibilityState;
(function (StudyUatDialogVisibilityState) {
    StudyUatDialogVisibilityState["None"] = "NONE";
    StudyUatDialogVisibilityState["Dialog"] = "DIALOG";
    StudyUatDialogVisibilityState["Capture"] = "CAPTURE";
})(StudyUatDialogVisibilityState = exports.StudyUatDialogVisibilityState || (exports.StudyUatDialogVisibilityState = {}));
class StudyUat {
}
exports.StudyUat = StudyUat;
class StudyUatComment {
}
exports.StudyUatComment = StudyUatComment;
//# sourceMappingURL=studyUat.js.map